import { render } from "./RegionalContent.vue?vue&type=template&id=87f4fbb8&scoped=true"
import script from "./RegionalContent.vue?vue&type=script&lang=js"
export * from "./RegionalContent.vue?vue&type=script&lang=js"

import "./RegionalContent.vue?vue&type=style&index=0&id=87f4fbb8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-87f4fbb8"]])

export default __exports__